import styled from 'styled-components';

import { adSlotConfig } from '../../ad-slot-config';
import { useDefineSlot } from '../../hooks/use-define-slot';

const AdContainer = styled.div`
  height: 600px;
`;

export const DisplayAdLogoutHalfpage02: React.FC<{ refresh: boolean }> = ({
  refresh,
}) => {
  const slotConfig = adSlotConfig.Logout.Halfpage02;
  useDefineSlot({ ...slotConfig, refresh });

  return <AdContainer id={slotConfig.id} />;
};
